import { DesktopShell, T } from '@/components/dashboard/DashboardShell';
import ChatAssistant from './ChatAssistant';

export default function OwletAIDesktop() {
  return (
    <DesktopShell title="Owlet AI" subtitle="Your university assistant — ask about classes, exams, rooms & more">
      <div style={{
        height: 'calc(100vh - 210px)', minHeight: 480,
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: 16, overflow: 'hidden',
      }}>
        <ChatAssistant />
      </div>
    </DesktopShell>
  );
}
